module.exports = __webpack_public_path__ + "static/media/ico-alert-danger.34422266.svg";